import USER_REVIEWS from "../../constants/user_reviews";
import TestimonialCard from "../Metrics/TestimonialCard";
import Styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import { getMobileOperatingSystem } from "../../constants/utils";

const UserReviews = () => {
  const isiOS = getMobileOperatingSystem() === "iOS";

  return (
    <div className={Styles.ReviewsContainer}>
      <p className={isiOS ? iStyles.ReviewsTitle : Styles.ReviewsTitle}>
        People ❤️ Evolve
      </p>
      <p className={isiOS ? iStyles.ReviewsSubtitle : Styles.ReviewsSubtitle}>
        Become part of a 1 million+ growing community
      </p>

      {/* The container remains, but its content will be simpler */}
      <div className={Styles.UserReviews}>
        <div className={Styles.UserReviewsWrapper}>
          {USER_REVIEWS.map((review, index) => (
            // ✨ This new wrapper is the key
            <div key={index} className={Styles.CardWrapper}>
              <TestimonialCard
                description={review.description}
                author={review.author}
                className={Styles.TestimonialCard}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserReviews;